var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBalance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-balance",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1.55,28a1.546,1.546,0,0,1-.2-3.08l.2-.031h1.4V15.556a1.479,1.479,0,0,1,1.27-1.524L4.429,14h5.9V7.778A1.454,1.454,0,0,1,11.6,6.252l.207-.03h5.9V1.556A1.509,1.509,0,0,1,19.19,0h7.381a1.509,1.509,0,0,1,1.476,1.556V24.889h1.4a1.546,1.546,0,0,1,.2,3.08l-.2.031Zm8.783-10.889H5.9v7.778h4.429Zm7.381-7.778H13.286V24.889h4.429ZM25.1,3.111H20.667V24.889H25.1Z",
    fill: "#f8fafd",
    fillRule: "evenodd"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBalance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-balance.fc10f74d.svg";
export { ForwardRef as ReactComponent };